(function() { window.GUID_c693ed6c_8ddf_4528_8a40_197475eac3fb = { getGuid: function() { return "c693ed6c-8ddf-4528-8a40-197475eac3fb"; } }; })();
var CompuSport;
(function (CompuSport) {
    var Controls;
    (function (Controls) {
        var Base;
        (function (Base) {
            class BaseControl {
            }
            Base.BaseControl = BaseControl;
        })(Base = Controls.Base || (Controls.Base = {}));
    })(Controls = CompuSport.Controls || (CompuSport.Controls = {}));
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=BaseControl.js.map
